import { render, staticRenderFns } from "./GlobalWatchTab.vue?vue&type=template&id=a0d60e1c&scoped=true&"
import script from "./GlobalWatchTab.vue?vue&type=script&lang=js&"
export * from "./GlobalWatchTab.vue?vue&type=script&lang=js&"
import style0 from "./GlobalWatchTab.vue?vue&type=style&index=0&id=a0d60e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d60e1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
